// extracted by mini-css-extract-plugin
module.exports = {"toggle":"toggle-switch__toggle___rYkUW"};